
// @flow
import WebComponent from '../webComponents/WebComponent';

export default class Form extends WebComponent {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  didMount() {
    const {
      preventMultipleSubmit,
    } = this.props;

    if (preventMultipleSubmit !== false) this.on('submit', this.handleSubmit);
  }

  /*
    Zamezeni pred vicenasobnym odeslanim formulare
   */
  handleSubmit() {
    const submitElements = this.element.querySelectorAll('[type="submit"]');
    setTimeout(() => {
      if (submitElements) {
        submitElements.forEach((submitElement) => {
          submitElement.setAttribute('disabled', 'disabled');
        });
      }
    }, 1)
  }
}




// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/components/Form.js